
import { ReactNode, useState } from "react";
import { LogoApp } from "../../../Components/LogoApp/LogoApp";
import { ButtonsContainer, ButtonSignIn, HeaderContainer } from "../../SignInPage/HeaderSignIn/Header.styled";
import { ModelWindow } from "../../../Components/ModelWindow/ModelWindow";
import { SignInModel } from "../../../Components/Public/WelcomePage/Header/SignInModel/SignInModel";
import { useLanguageContext } from "../../../Components/Languages/Langs/LanguageContext";

interface SignUpHeaderProps {
  children?: ReactNode;
}

export const SignUpHeader = ({ children }: SignUpHeaderProps) => {
  const { t } = useLanguageContext();
  const [showSignIn, setShowSignIn] = useState(false);
  const [isSignInOpen, setIsSignInOpen] = useState(false);

  const openSignIn = () => {
    setShowSignIn(true);
    setTimeout(() => setIsSignInOpen(true), 0);
  };

  const closeSignIn = () => {
    setIsSignInOpen(false);
    setTimeout(() => setShowSignIn(false), 250);
  };

  return (
    <>
      <header>
        <HeaderContainer>
          <a
            href="/"
            onClick={() => (window.location.href = "/")}
          >
            <LogoApp />
          </a>

          <ButtonsContainer>
            <ButtonSignIn type="button" onClick={openSignIn}>
              {t("publicTranslate.FormsAndModel.PageSignUp.Header.ButtonSignIn")}
            </ButtonSignIn>
          </ButtonsContainer>
        </HeaderContainer>

        {showSignIn && (
          <ModelWindow onClose={closeSignIn} isOpen={isSignInOpen}>
            <SignInModel onClose={closeSignIn} />
          </ModelWindow>
        )}
      </header>
    </>
  );
};
